var _rect, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "url(#paint0_linear_12237_127033)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.48484 15.249C7.25359 19.7733 6.22652 23.9875 6.23227 23.9859C6.11871 24.4552 6.25671 24.9816 6.63765 25.3628C7.01877 25.7436 7.54527 25.8821 8.01484 25.7685C8.01327 25.7741 12.2271 24.7471 16.7515 23.5157C18.4291 19.0791 20.14 14.649 21.7095 10.291C17.3516 11.8604 12.9215 13.5713 8.48484 15.249Z",
    fill: "url(#paint1_linear_12237_127033)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.2922 6.7083C25.6765 7.09305 25.8231 7.61617 25.7189 8.07936C25.72 8.07923 25.0158 11.2249 24.0279 15.003C24.0241 15.0186 24.0202 15.0341 24.0162 15.0497C22.9025 19.333 21.4622 24.4236 20.9162 26.3537C20.773 26.8597 20.6913 27.1484 20.6931 27.1484C20.6204 27.4061 20.4777 27.651 20.2649 27.8496C19.6924 28.3855 18.8246 28.3603 18.2956 27.8199C16.8351 26.329 15.3408 24.814 13.8311 23.2934C13.149 22.6063 13.076 21.5184 13.6685 20.7547C14.6943 19.4318 15.727 18.1046 16.7572 16.7809C17.7633 15.488 18.767 14.1983 19.7591 12.9188C20.1011 12.4779 19.5229 11.8997 19.0821 12.2417C17.7949 13.2399 16.4974 14.2496 15.1967 15.2618C13.8806 16.286 12.5613 17.3126 11.2461 18.3324C10.4825 18.925 9.39476 18.8521 8.70751 18.1698C7.18695 16.6602 5.67195 15.1658 4.18114 13.7054C3.64064 13.1762 3.61557 12.3086 4.15145 11.7359C4.35051 11.5232 4.59501 11.3802 4.85226 11.3075C4.85229 11.3094 5.15063 11.225 5.6722 11.0775C7.62142 10.5261 12.6884 9.09303 16.9539 7.98409C16.9539 7.98405 16.9538 7.98402 16.9538 7.98398C20.7513 6.99005 23.9214 6.2803 23.9214 6.2818C24.384 6.17723 24.9077 6.3238 25.2922 6.7083Z",
    fill: "url(#paint2_linear_12237_127033)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12237_127033",
    x1: 1.10345,
    y1: 16,
    x2: 31.4483,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3856DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A2CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12237_127033",
    x1: 9.33305,
    y1: 22.0007,
    x2: 25.3328,
    y2: 7.33366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BD3DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8F8F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_12237_127033",
    x1: -4.71306,
    y1: 36.7089,
    x2: 34.5299,
    y2: -2.53407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85FFE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2339,
    stopColor: "#9DFFE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7251,
    stopColor: "#DAFFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.db3922ad2d61ff3492ba88b449e052e8.svg";
export { ForwardRef as ReactComponent };